import { ApiService, ApiVersion, buildUrl } from '@/utils/api';

export const API_VERSION = {
  [ApiService.MAKGEOLLI]: ApiVersion.V6,
  [ApiService.GIN]: ApiVersion.V5,
  [ApiService.MOJITO]: ApiVersion.V7,
  [ApiService.REPORT]: ApiVersion.V11,
  [ApiService.SOLSTICE]: ApiVersion.V1,
  [ApiService.USER]: ApiVersion.V4,
  [ApiService.ZEPHYR]: ApiVersion.V1,
  [ApiService.LEMONADE]: ApiVersion.V1,
  [ApiService.PAOLYTA]: ApiVersion.V1,
};

export const DEFAULT_TIMEOUT = 120000;
export const HUGE_DATA_BACKEND_TIMEOUT = 130000; // for trigger backend timeout (2 mins)
export const SYNC_TIMEOUT = 601000; // for sync timeout (10 mins)

export const MAINTENANCE_CHECK_INTERVAL = 60 * 1000;
export const POLLING_INTERVAL = 10000;

export const LOADING_DELAY_THRESHOLD = 1000;

// due to circular dependency
export const postUserAuthLoginUrl = () =>
  buildUrl({
    service: ApiService.USER,
    version: API_VERSION[ApiService.USER],
    path: `/auth/login`,
  });

// due to circular dependency
export const getUserUserIsResetPasswordUrl = () =>
  buildUrl({
    service: ApiService.USER,
    version: API_VERSION[ApiService.USER],
    path: `/user/is_reset_password`,
  });
